import React, {useState, useEffect} from "react";
import MusicDashboard from '../../layouts/musicDashboard';
import AccountNav from '../../elements/accountElements/accountNav';
import RecentTickets from '../../components/helpdesk/recentTickets';
import TicketSummary from '../../components/helpdesk/ticketSummary';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Pagination from "react-js-pagination";
import {connect} from 'react-redux';
import * as helpdeskAction from '../../store/helpdesk/actions';

const  HelpdeskTickets = ({ getTickets, tickets }) => {
  
    const [ page, setPage ] = useState();
    const [ status, setStatus ] = useState();
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => { 
		// load Page Data
		loadPageData();
    },[location]);


    const loadPageData = async() => {
        let ticketStatus = 'all';
        if(location.pathname == '/helpdesk/tickets/open'){
            ticketStatus = 'open';
        } else if(location.pathname == '/helpdesk/tickets/close'){
            ticketStatus = 'close';
        }
        setStatus(ticketStatus);
        await getTickets({page: 1, pageLimit: 10, status: ticketStatus});
        window.scrollTo({top: 0});
    }
    const handlePageChange = async (pageNumber) => {
        setPage(pageNumber);
        await getTickets({page: pageNumber, pageLimit: 10, status: status}).then((res) => {});
        window.scrollTo({top: 0});
    }
    

  return (
    <MusicDashboard  accountPages={true} middleSectionCssClass={'account-info-sec full-section'}>
       	<div className="content-sec">
            <div className="account-block">
                <div className="top-heading">
                    <h2>HELP DESK</h2>
                </div>
                <AccountNav />
                <div className="top-heading">
                    <div className="back-arrow-head">
                        <span onClick={() => navigate(-1)} className="cp">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 6L8.09618 9.78462C8.06582 9.81224 8.04162 9.8456 8.02508 9.88265C8.00853 9.91969 8 9.95963 8 10C8 10.0404 8.00853 10.0803 8.02508 10.1174C8.04162 10.1544 8.06582 10.1878 8.09618 10.2154L12 14" stroke="#080A0D" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </span>
                        <h3>Tickets</h3>
                    </div>
                </div>
                <div className="account-inner-block">
                    <div className="ticket-sec">
                        <div className="inner-ticket-block">
                            <div className="left">
                                <TicketSummary />
                            
                                <div className="table-content">
								<Table hover responsive>
									<thead>
                                        <tr>
										<th>#Ticet</th>
                                            <th>Last Updated</th>
                                            <th>Subject</th>
                                            <th>&nbsp;</th>
									</tr>
                                    </thead>
                                    {
                                        tickets && tickets.tickets && tickets.tickets.length > 0 ?
                                        <tbody>
                                            {
                                                tickets.tickets.map((ticket, index)=>{
                                                    return <tr key={`ticket-list${index}`}>
                                                            <td>{ticket.ticket_number}</td>
                                                            <td>{ticket.modified_at}</td>
                                                            <td>{ticket.subject}</td>
                                                            <td><Link to={`/helpdesk/ticket/details/${ticket.ticket_number}`}>View</Link></td>
                                                    </tr>
                                                })
                                            }	
                                            
                                        </tbody>
                                        : ''
                                    }
                                </Table>
							</div>
                                {/* <Table hover responsive>
                                    <thead>
                                        <tr>
                                            <th>#Ticet</th>
                                            <th>Last Updated</th>
                                            <th>Subject</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    {
                                        tickets && tickets.tickets && tickets.tickets.length > 0 ?
                                        <tbody>
                                            {
                                                tickets.tickets.map((ticket, index)=>{
                                                    return <tr key={`ticket-list${index}`}>
                                                            <td>{ticket.ticket_number}</td>
                                                            <td>{ticket.modified_at}</td>
                                                            <td>{ticket.subject}</td>
                                                            <td><Link to={`/helpdesk/ticket/details/${ticket.ticket_number}`}>View</Link></td>
                                                    </tr>
                                                })
                                            }	
                                            
                                        </tbody>
                                        : ''
                                    }
                                </Table> */}
                            </div>
                            <RecentTickets />
                        </div>
                        <div className="pagingnation-sec">
                        {
                        tickets && tickets.pagination ? 
                            <Pagination
                                activePage={tickets.pagination.page}
                                itemsCountPerPage={tickets.pagination.perPageLimit}
                                totalItemsCount={tickets.pagination.totalCount}
                                // pageRangeDisplayed={pageRangeDisplayed}
                                onChange={handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                        /> : ''
                        }
                        </div>
                    </div>
                </div>
            </div>
		</div>
    </MusicDashboard>
  );
}

function mapStateToProps(state) {
    return {
        tickets: state.helpdesk.tickets
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getTickets: (post) => dispatch(helpdeskAction.getTickets(post))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpdeskTickets);